// 這是Webpack掛載起始點
import Layout from './layout.vue'
import Index from '../.components/index.vue'

const main_router = 'driver_commissions'

const router = [
    {
        path: '/',
        component: Index,
        name: 'driver_commissions',
        meta: {
            api_name: 'api_v1_provider_driver_commissions',
            breadcrumb: [main_router]
        }
    },
]


export default router
